/**
 * @flow
 * @format
 */

import _ModalWrapper from './ModalWrapper';

export default _ModalWrapper;



// WEBPACK FOOTER //
// ./src/components/ModalWrapper/index.js